import { useMemo } from 'react';
import { useTranslation } from 'react-i18next';

const useMessagesLoaderLabels = () => {
  const { t } = useTranslation('messages-loader');

  return useMemo(
    () => [
      t('readingBrief'),
      t('complainingBrief'),
      t('goingOutForOatMilkLatte'),
      t('pretendingToWorkWhileDoomscrolling'),
      t('lookingAtLatestCannesReels'),
      t('comingUpWithTrumpJokes'),
      t('lookingAtBriefAgain'),
      t('textingAboutDinnerPlans'),
      t('googlingMyOwnName'),
      t('badMouthingOtherAgencies'),
      t('preparingForMakeLogoBiggerResponse'),
      t('writingTwentyBuildUpSlides'),
      t('thinkingAboutGoingFreelance'),
      t('watchingTikTokForTrendResearch'),
      t('joiningAnotherMeetingOnTeams'),
      t('obsessingOverRightIdea'),
      t('writingCoolQuoteForLinkedin'),
      t('refreshingGmail'),
      t('wonderingIfWeCanPushToNextWeek'),
      t('ohLookSquirrel'),
    ],
    [t],
  );
};

export default useMessagesLoaderLabels;
